var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { CHANGE_CURRENT_STATE, ChangeCurrentStateAction, ChangeStatesFlowIfEmptyAction, CurrentStateChangedAction, FINISH_FIRST_STEPS, FinishFirstStepsAction, GO_TO_NEXT_APP_CONFIGURATION, GO_TO_NEXT_STATE, LOAD_INITIAL_STATE } from './first-steps.actions';
import { getCurrentStateSelector, getStatesFlowSelector } from './first-steps.reducer';
import { filter, map, mergeMap, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { from } from 'rxjs';
import { defaultFirstStepsFlow, firstStateForMobile, firstStepsConfigurationSteps } from './first-steps.flow';
import { isMobile } from '../shared/utils/screen-width';
var FirstStepsEffects = /** @class */ (function () {
    function FirstStepsEffects(actions$, store, router) {
        var _this = this;
        this.actions$ = actions$;
        this.store = store;
        this.router = router;
        this.handleNextState = this.actions$.pipe(ofType(GO_TO_NEXT_STATE), withLatestFrom(this.store.select(getStatesFlowSelector), this.store.select(getCurrentStateSelector)), map(function (_a) {
            var statesFlow = _a[1], currentState = _a[2];
            return [statesFlow, currentState];
        }), filter(function (_a) {
            var statesFlow = _a[0];
            return !!statesFlow && !!statesFlow.length;
        }), map(function (_a) {
            var statesFlow = _a[0], currentState = _a[1];
            if (!currentState) {
                return new ChangeCurrentStateAction(statesFlow[0]);
            }
            var currentStateIndex = statesFlow.indexOf(currentState);
            if (currentStateIndex === statesFlow.length - 1) {
                console.log('finish first steps');
                return new FinishFirstStepsAction();
            }
            return new ChangeCurrentStateAction(statesFlow[currentStateIndex + 1]);
        }));
        this.goToNextAppConfiguration = this.actions$.pipe(ofType(GO_TO_NEXT_APP_CONFIGURATION), withLatestFrom(this.store.select(getStatesFlowSelector), this.store.select(getCurrentStateSelector)), map(function (_a) {
            var statesFlow = _a[1], currentState = _a[2];
            return [statesFlow, currentState];
        }), filter(function (_a) {
            var statesFlow = _a[0];
            return !!statesFlow && !!statesFlow.length;
        }), map(function (_a) {
            var statesFlow = _a[0], currentState = _a[1];
            if (!currentState) {
                return new ChangeCurrentStateAction(statesFlow[0]);
            }
            var currentConfigurationStepIndex = firstStepsConfigurationSteps.findIndex(function (regex) { return regex.test(currentState); });
            if (currentConfigurationStepIndex === firstStepsConfigurationSteps.length - 1) {
                return new FinishFirstStepsAction();
            }
            var nextState = statesFlow.find(function (state) {
                return firstStepsConfigurationSteps[currentConfigurationStepIndex + 1].test(state);
            });
            return new ChangeCurrentStateAction(nextState);
        }));
        this.changeCurrentState = this.actions$.pipe(ofType(CHANGE_CURRENT_STATE), map(function (action) { return action.payload; }), switchMap(function (state) { return from(_this.router.navigate(['first-steps', state]).then(function () { return state; })); }), map(function (state) { return new CurrentStateChangedAction(state); }));
        this.loadInitialState = this.actions$.pipe(ofType(LOAD_INITIAL_STATE), withLatestFrom(this.store.select(getStatesFlowSelector), this.store.select(getCurrentStateSelector)), map(function (_a) {
            var statesFlow = _a[1], currentState = _a[2];
            return [statesFlow, currentState];
        }), mergeMap(function (_a) {
            var statesFlow = _a[0], currentState = _a[1];
            var flow = statesFlow || defaultFirstStepsFlow;
            var stateToGo = currentState || (isMobile() ? firstStateForMobile(flow) : flow[0]);
            if (!statesFlow) {
                return [new ChangeStatesFlowIfEmptyAction(flow), new ChangeCurrentStateAction(stateToGo)];
            }
            return [new ChangeCurrentStateAction(stateToGo)];
        }));
        this.finishFirstSteps = this.actions$.pipe(ofType(FINISH_FIRST_STEPS), tap(function () {
            _this.router.navigate(['onboarding']);
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], FirstStepsEffects.prototype, "handleNextState", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], FirstStepsEffects.prototype, "goToNextAppConfiguration", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], FirstStepsEffects.prototype, "changeCurrentState", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], FirstStepsEffects.prototype, "loadInitialState", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], FirstStepsEffects.prototype, "finishFirstSteps", void 0);
    return FirstStepsEffects;
}());
export { FirstStepsEffects };
